import React from 'react';
import styles from './style.module.scss';
import LottieAnimation from 'shared/components/lottie_animation/LottieAnimation';
import classNames from 'classnames';
function OverlayLoading() {
    return (
        <div className={styles.Loader}>
            <div className={classNames(styles.LoadingContent)}>
                <LottieAnimation />
            </div>
        </div>
    );
}

export default OverlayLoading;
